import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store/store';
import './index.css';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import './App.scss';
import ErrorBoundary from './shared/components/errorBoundary/errorBoundary';
import {SnackbarProvider} from "notistack"

// Recover from stale chunk references after a new deploy: when a lazily-loaded
// chunk fails to load (an old index.html pointing at replaced hashes), reload
// once to fetch the fresh index.html and chunks. Guarded against reload loops.
const handleChunkLoadError = (reason: any) => {
  const name = reason?.name || '';
  const message = String(reason?.message || reason || '');
  const isChunkError =
    name === 'ChunkLoadError' ||
    /Loading (CSS )?chunk [\w-]+ failed/i.test(message);
  if (!isChunkError) return;
  const KEY = 'chunkReloadTs';
  const last = Number(sessionStorage.getItem(KEY) || '0');
  if (Date.now() - last < 15000) return; // already reloaded very recently
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
};
window.addEventListener('error', (e: any) => handleChunkLoadError(e?.error || e));
window.addEventListener('unhandledrejection', (e: any) => handleChunkLoadError(e?.reason));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

let persistor = persistStore(store);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <SnackbarProvider>
            <App />
          </SnackbarProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
